// extracted by mini-css-extract-plugin
export default {"button_light":"ButtonLight_button_light__BNlao"};